<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'employee.sendRequest.label' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form" (submit)="submit()" class="dialog-form">
      <section class="app-dialog__section">
        <header class="app-dialog__section-head">
          <h3>{{ 'employee.sendRequest.messageSection' | translate }}</h3>
        </header>

        <div class="meta-row">
          <div class="field">
            <label class="field__label">{{ 'employee.sendRequest.subject' | translate }}</label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input matInput formControlName="subject" type="text" [errorStateMatcher]="errorStateMatcher">
              <mat-error *ngIf="form.hasError('required', ['subject'])">
                {{ 'fieldRequired' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="field">
          <label class="field__label">{{ 'employee.sendRequest.body' | translate }}</label>
          <div class="editor-shell">
            <app-editor formControlName="body" [height]="editorHeight"></app-editor>
          </div>
          <div class="field__error" *ngIf="errorStateMatcher.submitAttempted && form.hasError('required', ['body'])">
            {{ 'fieldRequired' | translate }}
          </div>
        </div>
      </section>

      <section class="app-dialog__section">
        <header class="app-dialog__section-head app-dialog__section-head--row">
          <h3>{{ 'employee.sendRequest.targetLabel' | translate }}</h3>
          <span class="selected-pill" *ngIf="selectedEmployees.length > 0">
            {{ selectedEmployees.length }}
          </span>
        </header>

        <div class="field">
          <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
            <input
              matInput
              [formControl]="searchControl"
              [placeholder]="'employee.searchPlaceholder' | translate"
              [attr.aria-label]="'employee.search' | translate"
            />
            <mat-icon matPrefix>search</mat-icon>
          </mat-form-field>
        </div>

        <div class="employee-table-shell">
          <table mat-table [dataSource]="filteredEmployees">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="$event ? masterToggle() : null"
                  [checked]="isAllSelected()"
                  [indeterminate]="!isAllSelected() && selectedEmployees.length > 0">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let employee">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? toggleEmployeeSelection(employee) : null"
                  [checked]="isEmployeeSelected(employee)">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="fullName">
              <th mat-header-cell *matHeaderCellDef>{{ 'employee.fullName' | translate }}</th>
              <td mat-cell *matCellDef="let employee">{{ employee.fullName }}</td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>{{ 'employee.email' | translate }}</th>
              <td mat-cell *matCellDef="let employee">{{ employee.email }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              (click)="toggleEmployeeSelection(row)"
              [class.row-selected]="isEmployeeSelected(row)">
            </tr>
          </table>

          <div class="employee-table-shell__overlay" *ngIf="isLoadingEmployees">
            <app-loading></app-loading>
          </div>

          <div class="employee-table-shell__empty" *ngIf="!isLoadingEmployees && filteredEmployees.length === 0">
            <p>{{ 'branchSettings.noEmployeesFound' | translate }}</p>
          </div>
        </div>
      </section>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'cancel' | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="submit()"
      [disabled]="sendingRequest || selectedEmployees.length === 0">
      <mat-icon *ngIf="!sendingRequest">send</mat-icon>
      <mat-spinner diameter="20" class="dc-btn-spinner" *ngIf="sendingRequest"></mat-spinner>
      <span *ngIf="!sendingRequest">{{ 'send' | translate }}</span>
    </button>
  </footer>
</div>
